import { RgbaColor } from 'react-colorful';

export const rgbaToHex = (rgba: RgbaColor): string => {
    // Ensure each component is within the valid range (0-255)
    const red = Math.max(0, Math.min(255, rgba.r));
    const green = Math.max(0, Math.min(255, rgba.g));
    const blue = Math.max(0, Math.min(255, rgba.b));

    // Ensure alpha is within the valid range (0-1)
    const alpha = Math.max(0, Math.min(1, rgba.a));

    // Convert each component to its hexadecimal representation
    const redHex = red.toString(16).padStart(2, '0');
    const greenHex = green.toString(16).padStart(2, '0');
    const blueHex = blue.toString(16).padStart(2, '0');
    const alphaHex = Math.round(alpha * 255)
        .toString(16)
        .padStart(2, '0');

    // Concatenate the hexadecimal values with '#' to form the final color code
    return '#' + redHex + greenHex + blueHex + alphaHex;
};
